import React, { createContext, useContext, useState } from 'react'

export const LAYOUT_OPTIONS = ['grid', 'list'] as const

export type LayoutOption = (typeof LAYOUT_OPTIONS)[number]

interface ProductLayoutContextType {
    layoutOption: LayoutOption
    setLayoutOption: (option: LayoutOption) => void
}

const ProductLayoutContext = createContext<ProductLayoutContextType>({
    layoutOption: 'grid',
    setLayoutOption: () => {},
})

export const ProductLayoutProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const [layoutOption, setLayoutOption] = useState<LayoutOption>('grid')

    return (
        <ProductLayoutContext.Provider
            value={{ layoutOption, setLayoutOption }}
        >
            {children}
        </ProductLayoutContext.Provider>
    )
}

export const useProductLayout = () => {
    const context = useContext(ProductLayoutContext)
    if (!context) {
        throw new Error(
            'useProductLayout must be used within a ProductLayoutProvider',
        )
    }
    return context
}

export const useColumnCount = () => {
    const { layoutOption } = useProductLayout()
    return layoutOption === 'grid' ? 2 : 1
}
